module.exports = __webpack_public_path__ + "img/dashboard-setting.961c748d.png";